import React from "react";
import ImageGrid2Large from "../Images/ImageGrid2Large";
import resolvePath from "../../utils/resolvePath";
import {IMAGE_TWO_THIRDS} from "../../utils/variables";
import {
  OnImageInfoWrapper,
  OnImageTitle,
} from "../../utils/onImageTitles";
import Title from "../Title";
import styled from "styled-components";
import breakpoints from "../../utils/breakpoints";
import {mobileItemMargin, tabletItemMargin} from "../../utils/margins";
import NewsType from "../NewsType";
import {animations} from "../../utils/animations";
import {blockHover} from "../../utils/blockHover";
import {textOnImageHover} from "../../utils/textOnImageHover";
import {ItemLinkWrapper} from "../../utils/ItemLinkWrapper";
import {
  PUBLI_CLASS,
  PUBLI_REPORTS
} from "../../utils/constants";
import setScrollPosition from "../../utils/setScrollPosition";

const TwoThirdsMainWrapper = styled.div`
  position: relative;
  h2 {
    font-size: 18px;
    @media ${breakpoints.desktop} {
      font-size: 1.875rem;
    }
  }
  ${mobileItemMargin}
  ${tabletItemMargin}
  ${animations.image.unHover}
  ${blockHover}
  ${textOnImageHover}
  overflow: hidden;
`;
const TwoThirdsMainOuter = styled.div`
  &.publi {
    max-width: 620px;
    > div {
      margin-bottom: 0;
    }
    margin-bottom: 40px;
    @media ${breakpoints.desktop} {
      margin-bottom: 0;
    }
  }
`;

export default function TwoThirdsMain({ node }) {
  return (
    <TwoThirdsMainOuter className={node.shn_type === PUBLI_REPORTS ? PUBLI_CLASS : null}>
      <TwoThirdsMainWrapper>
        <ItemLinkWrapper href={node.link} title={node.title} onClick={() => setScrollPosition()}>
          <ImageGrid2Large imageSource={resolvePath(node, IMAGE_TWO_THIRDS)} link={node.link} altText={node.image_alt} titleText={node.image_title} />
          <OnImageInfoWrapper>
            <NewsType catchLine={node?.catchLine} newsType={node.shn_type} color={'white'} flag={node.flag} />
            <OnImageTitle>
              <Title title={node.title} paywall={node.paywall} />
            </OnImageTitle>
          </OnImageInfoWrapper>
        </ItemLinkWrapper>
      </TwoThirdsMainWrapper>
    </TwoThirdsMainOuter>
  );
}
